import React, {Component} from 'react';
import {getOrgAdmin} from './GetOrgAdmin';

class ManageSettings extends Component {
    state = {
        signedLegalAgreementTitle: "",
        signedLegalAgreementError:"",
        signedLegalAgreementHrefLink: "",
        adminUser: undefined
    }

    getSignedLegalAgreements = () => {
        fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/legalAgreements/signed', {
            method: 'GET',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
            },
        })
        .then(response => {
            if (response.ok) {
              response.json().then(json => {
                console.log(json);
                if(json.length === 0){
                  this.setState({
                    signedLegalAgreementError: 'No legal agreements found',
                  });
                } else {
                  this.setState({
                      signedLegalAgreementTitle:json[0].title,
                      signedLegalAgreementHrefLink:json[0].pdfLink,
                  });
                }
            });
            } else {
                console.log("Error geting SignedLegalAgreements from server: " + response.status);
                throw Error(response);
            }
        })
        .catch(error => {
            console.log("Error geting SignedLegalAgreements from server: " + error.message);
            if(error.status === 404){
              this.setState({
                signedLegalAgreementError: 'No legal agreements found',
              });
            } else {
              this.setState({
                signedLegalAgreementError: 'Unable to retreive legal agreement',
              });
            }
            return Promise.reject();
        });
    }

    componentDidMount() {
        const { currentUser } = this.props;
        this.getSignedLegalAgreements();
        if(currentUser != null && currentUser.opa === false){
            getOrgAdmin(this.orgAdminInfo);
        } else {
          this.setState({
            adminUser: currentUser,
          });
        }
    }

    orgAdminInfo = (adminUser) => {
        this.setState({
          adminUser: adminUser,
        });
    }
    render() {
        const {signedLegalAgreementHrefLink, signedLegalAgreementError, signedLegalAgreementTitle , adminUser} = this.state;
        const {currentUser} = this.props;

        return(
            <div className="container-fluid">
                <div className="row py-4">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 px-3 pb-4">
                                <h1><i className="fa fa-cog"/> Manage Settings</h1>
                            </div>
                        </div>
                        <div className="row">
                        {(currentUser.organization != null && currentUser.organization.memberType === "CORPORATE") &&
                            <div className="col-12 col-lg-6 orgDetails pb-4">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 col-lg-6">
                                                <h2 className="card-title">Org Details</h2>
                                            </div>
                                            {(currentUser.opa) &&
                                                <div className="col-12 col-lg-6 editLinkWrapper">
                                                    <a href="/developer/mvc/organization/manage/load" className="card-link">Edit
                                                        <i className="fa fa-edit"></i>
                                                    </a>
                                                </div>
                                              }
                                        </div>
                                        <p id="userOrgName" className="card-text"> {currentUser.organization.name}</p>
                                        {currentUser.organization.contacts[0].phoneNumber &&
                                            <p id="userPhoneNumer" className="card-text"> Phone: {currentUser.organization.contacts[0].phoneNumber}</p>
                                        }
                                        <p id="userAddress" className="card-text"> <a>{currentUser.organization.contacts[0].address1} {currentUser.organization.contacts[0].address2}</a></p>
                                        {currentUser.organization.contacts[0].city &&
                                            <p id="userCityStateZip" className="card-text"> <a>{currentUser.organization.contacts[0].city}, {currentUser.organization.contacts[0].state} {currentUser.organization.contacts[0].postalCode}</a></p>
                                        }
                                    </div>
                                </div>
                            </div>
                          }
                          {(currentUser.organization != null && currentUser.organization.memberType === "CORPORATE") &&
                            <div className="col-12 col-lg-6 pb-4">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 col-lg-6">
                                                <h2 className="card-title">Account Administrator</h2>
                                            </div>
                                              {(currentUser.opa) &&
                                                <div className="col-12 col-lg-6 editLinkWrapper">
                                                    <a href="/developer/mvc/user/manageProfile" className="card-link">Edit
                                                        <i className="fa fa-edit"></i>
                                                    </a>
                                                </div>
                                              }
                                        </div>
                                        {adminUser &&
                                            <p className="card-text"><a>{adminUser.firstName}</a> <a>{adminUser.lastName}</a></p>
                                        }
                                        {adminUser && adminUser.email &&
                                            <p className="card-text">Email: {adminUser.email}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                          }
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6 legalAgreements pb-4">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <h2 className="card-title">Accepted Legal Agreements</h2>
                                        {signedLegalAgreementTitle &&
                                        	<div>
                                            <div className="link-wrapper">
                                                <a href={signedLegalAgreementHrefLink} target="_blank" className="card-link">{signedLegalAgreementTitle}
                                                <i className="fas fa-download"></i></a>
                                            </div>
                                            <div className="link-wrapper">
	                                            <a href="/developer/mvc/legalAgreements/manage" className="card-link">Manage Legal Agreements</a>
                                            </div>
                                            </div>
                                        }
                                        {signedLegalAgreementError &&
                                            <div className="link-wrapper">
                                                <a className="card-link">{signedLegalAgreementError}</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 pb-4">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <h2 className="card-title">Login and Account Management</h2>
                                        <div className="link-wrapper">
                                            <p className="card-text">Manage your account settings</p>
                                            <a href="/developer/mvc/user/manageProfile" className="card-link">Account Settings &gt;</a>
                                        </div>
                                        <div className="link-wrapper">
                                            <p className="card-text">To close your account, click below</p>
                                            <a href="/firstnet/manage-my-account/cancel-my-account" className="card-link">Cancel My FirstNet Account &gt;</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ManageSettings;



// WEBPACK FOOTER //
// ./src/manageMyAccount/ManageSettings.js